var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "cart-layer toLayerPanier" }, [
    _c(
      "a",
      {
        attrs: { id: "cart-widget" },
        on: {
          click: function($event) {
            _vm.show({ isNotification: _vm.isNotification })
          }
        }
      },
      [
        _c("img", {
          staticClass: "svg",
          attrs: {
            src: "/bundles/site/img/shopping-bag-regular.svg",
            alt: "Panier"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "d-none d-lg-block" }, [_vm._v("Panier ")]),
        _vm._v(" "),
        _c("em", [_vm._v(_vm._s(_vm.countItems))])
      ]
    ),
    _vm._v(" "),
    _c(
      "nav",
      {
        staticClass: "cbp-spmenu cbp-spmenu-vertical cbp-spmenu-right",
        attrs: { id: "cbp-spmenu-s2" }
      },
      [
        _c("div", { attrs: { id: "layerHeader" } }, [
          _c(
            "span",
            {
              attrs: { id: "close-panel" },
              on: {
                click: function($event) {
                  _vm.hide()
                }
              }
            },
            [_vm._v("×")]
          )
        ]),
        _vm._v(" "),
        _vm.isNotification
          ? _c("div", { staticClass: "info added text-center" }, [
              _c("img", {
                staticClass: "svg",
                attrs: {
                  src: "/bundles/site/img/icoCheckCart.svg",
                  alt: "Produit ajouté au panier"
                }
              }),
              _vm._v("\n            Produit ajouté au panier\n        ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isEmpty
          ? _c("div", { staticClass: "info empty text-center" }, [
              _vm._v("\n            Votre panier est vide.\n        ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { attrs: { id: "layerPanier" } }, [
          _c("div", { attrs: { id: "cart" } }, [
            _c(
              "div",
              { staticClass: "zoneScroll" },
              [
                _vm._l(_vm.items, function(item) {
                  return null !== item.orderable &&
                    "site.repository.product_reference" ===
                      item.orderable.orderableRepository
                    ? _c("ponroy-cart-widget-item", {
                        key: item.id,
                        attrs: {
                          type: item.orderable.orderableRepository,
                          reference: item.id,
                          title: item.orderable.data.title,
                          referenceTitle: item.referenceName,
                          total: item.total,
                          unitsTotal: item.unitsTotal,
                          quantity: item.quantity,
                          mainImage: item.orderable.data.cardImage
                        }
                      })
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(_vm.items, function(item) {
                  return null !== item.orderable &&
                    "site.repository.fidelity_gift" ===
                      item.orderable.orderableRepository
                    ? _c("ponroy-cart-widget-item", {
                        key: item.id,
                        attrs: {
                          type: item.orderable.orderableRepository,
                          reference: item.id,
                          title: item.orderable.title,
                          total: item.totalFidelityPoint,
                          unitsTotal: 0,
                          quantity: item.quantity,
                          mainImage: item.orderable.image
                        }
                      })
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(_vm.items, function(item) {
                  return null !== item.orderable &&
                    "site.repository.gift" ===
                      item.orderable.orderableRepository &&
                    item.orderable.type !== "sample" &&
                    item.orderable.type !== "doc"
                    ? _c("ponroy-cart-widget-item", {
                        key: item.id,
                        attrs: {
                          type: item.orderable.orderableRepository,
                          reference: item.id,
                          title: item.orderable.title,
                          total: item.total,
                          unitsTotal: item.unitsTotal,
                          quantity: item.quantity,
                          mainImage: item.orderable.image
                        }
                      })
                    : _vm._e()
                }),
                _vm._v(" "),
                0 < _vm.filtredRecommendedProducts.length
                  ? _c("div", { attrs: { id: "recos" } }, [
                      _c("div", { staticClass: "titleRecos" }, [
                        _vm._v("Nous vous recommandons")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "zoneRecos" },
                        _vm._l(_vm.recommendedProductForLayer, function(item) {
                          return !_vm.inCart(item.id)
                            ? _c("div", { staticClass: "miniProduct" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.showProduct(
                                          item.product.id,
                                          item.product.slug
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row",
                                        staticStyle: { "align-items": "center" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-4",
                                            staticStyle: {
                                              "padding-right": "0"
                                            }
                                          },
                                          [
                                            item.product.catalogImage
                                              ? _c("img", {
                                                  staticClass:
                                                    "lazyload img-fluid",
                                                  attrs: {
                                                    "data-src":
                                                      item.product.catalogImage
                                                        .path,
                                                    alt: item.product.title
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-8" }, [
                                          _c("div", [
                                            item.product.isNewFormula
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-secondary"
                                                  },
                                                  [_vm._v("Nouvelle formule")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.product.isNew
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-secondary"
                                                  },
                                                  [_vm._v("Nouveauté")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.product.bestSales
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-secondary"
                                                  },
                                                  [_vm._v("Meilleures ventes")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.product.provenSatisfaction
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-secondary"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Satisfaction prouvée"
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.product.provenEffectiveness
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-secondary"
                                                  },
                                                  [_vm._v("Efficacité prouvée")]
                                                )
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            item.name
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(item.name) +
                                                      " -\n                                            "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(item.product.title) +
                                                "\n                              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(item.product.subtitle)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", { staticClass: "prix" }, [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm._f("moneyFormat")(
                                                    item.discountedPrice > 0
                                                      ? item.discountedPrice
                                                      : item.price
                                                  )
                                                ) +
                                                "\n\n                                "
                                            ),
                                            item.discountedPrice > 0
                                              ? _c(
                                                  "del",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "normal"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                  " +
                                                        _vm._s(
                                                          _vm._f("moneyFormat")(
                                                            item.price
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-right" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.addRecommendation(item)
                                        }
                                      }
                                    },
                                    [_vm._v("Ajouter au panier")]
                                  )
                                ])
                              ])
                            : _vm._e()
                        })
                      )
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row bigTotal" }, [
              _c("div", {}, [_vm._v("Total de vos articles")]),
              _vm._v(" "),
              _c("div", {}, [
                _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.itemsTotalDiscounted)))
              ])
            ]),
            _vm._v(" "),
            _vm.discountAmount > 0
              ? _c("div", { staticClass: "text-center benefices" }, [
                  _vm._v("Vous bénéficiez de "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.discountAmount)))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shippingFees && 0 == _vm.shippingFees.amount
              ? _c("div", { staticClass: "text-center benefices" }, [
                  _vm._v("Vous bénéficiez de "),
                  _c("strong", [_vm._v("la livraison offerte")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary show-cart",
                attrs: { href: "/panier" }
              },
              [_vm._v("Voir mon panier")]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9563da50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9563da50","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/CartSidebar.vue
// module id = 542
// module chunks = 1